import { ReactNode } from 'react';
import { useEnabledFeatures } from '../hooks/enabled-features/use-enabled-features';

type DataPrivacyProps = {
    /**
     * - `unmask` — unmasks text for Datadog Session Replay, except form inputs (`data-dd-privacy="mask-user-input"`)
     * - `mask` — forces masking; use to re-mask content inside an `unmask` boundary (`data-dd-privacy="mask"`)
     * - `passthrough` — renders children with no wrapper; no Datadog attribute applied
     */
    privacy: 'unmask' | 'mask' | 'passthrough';
    children: ReactNode;
};

const PRIVACY_ATTRIBUTE: Record<Exclude<DataPrivacyProps['privacy'], 'passthrough'>, string> = {
    unmask: 'mask-user-input',
    mask: 'mask',
};

export function DataPrivacy({ privacy, children }: DataPrivacyProps) {
    const { datadogUnmaskingEnabled } = useEnabledFeatures();
    if (!datadogUnmaskingEnabled) {
        return <>{children}</>;
    }
    if (privacy === 'passthrough') {
        return <>{children}</>;
    }
    return (
        <div data-dd-privacy={PRIVACY_ATTRIBUTE[privacy]} style={{ display: 'contents' }}>
            {children}
        </div>
    );
}
